import { Pane, Polyline, } from 'react-leaflet';

/**
 * 除雪エリアの描画パラメータクラス
 *
 * 除雪エリアとその出動予測をreact-leafletで描画した地図上に重ねて描画する際の
 * - エリアを表す折れ線の座標
 * を司る。
 */
class SnowRemovalLinesPaneParameter {
  constructor(positions) {
    this.positions = positions;
  }
}

/**
 * 除雪エリアペインクラス
 *
 * このペイン内に除雪エリアの折れ線を描画する。
 * ペインでラップしている理由はz-indexを設定するため。
 * 地図そのものよりも手前に重ねて表示したいので、地図のz-index（500）よりも
 * 1だけ大きな値を設定している。
 *
 * @param snowRemovalLinesPaneParameters 除雪エリアの描画パラメータクラスの配列。描画したいエリアの数 == この配列の要素数
 * @param probabilities                  出動予測値の配列。snowRemovalLinesPaneParametersの要素数と一致させる必要あり。
 */
const SnowRemovalLinesPane = (props) => {

    const { snowRemovalLinesPaneParameters, probabilities } = props;

    return (
        <Pane name="polyline" style={{ zIndex: 501 }}>
            {Array.isArray(snowRemovalLinesPaneParameters) && snowRemovalLinesPaneParameters.map((parameter, index) => (
                <Polyline
                    pathOptions={{ color: probabilities[index] < 0.3 ? 'blue' : probabilities[index] < 0.8 ? 'yellow' : 'red' }}
                    positions={parameter.positions}
                />
            ))}
        </Pane>
    );
};

export {SnowRemovalLinesPane, SnowRemovalLinesPaneParameter};
